import React, { Component } from 'react'

export default class index extends Component {
    render() {
        return (
            <h1 className={this.props.pointer == true ? "select-heading cursor-pointer" : "select-heading"} onClick={this.props.backToPrivious}>
                {this.props.name}
            </h1>
        )
    }
}
